import store from '@/store'

export default {
  data () {
    return {
      store
    }
  },
  computed: {
    selectListStack: {
      get () {
        return this.store.selectListStack
      },
      set (newValue) {
        this.store.selectListStack = newValue
      }
    },
    selectListPeek () {
      return this.selectListStack.length && this.selectListStack[this.selectListStack.length - 1]
    }
  },
  methods: {
    setState (state) {
      Object.assign(this.store, state)
    },
    // filedValue 查询参数value
    toggleQuery (field, otherFields, backStep, filedValue = 1) {
      if (this.$route.query[field] && ((!!otherFields && !otherFields.wps_edit) || !otherFields)) {
        // TODO: 可在FileSelect destroyed 时清空  selectListStack
        if (field === 'movecopy' || field === 'sharesave') {
          this.selectListStack = []
        }
        if (field === 'filenav') {
          var filenavQuery
          filenavQuery = { ...this.$route.query }
          delete filenavQuery.filenav
          this.$router.replace({ filenavQuery })
          return
        }
        this.$router.go(backStep || -1)
      } else {
        var query
        if (otherFields === undefined) {
          query = { ...this.$route.query, [field]: filedValue }
        } else {
          query = { ...this.$route.query, [field]: filedValue, ...otherFields }
        }
        if (query.actionsheet) {
          delete query.actionsheet
          this.$router.replace({ query })
        } else {
          this.$router.push({ query })
        }
      }
    }
  }
}
